// Kirana Emerald Design System - Public Brand Theme
// Primary: Emerald Green #059669 | Accent: Warm Amber #F59E0B

export const PUBLIC_BRAND_THEME = {
  primary: '#059669',
  primaryDark: '#047857',
  accent: '#F59E0B',
  accentStrong: '#D97706',
  accentSoft: '#FEF3C7',
  text: '#111827',
  muted: '#6B7280',
  surface: '#FFFFFF',
  surfaceTint: 'rgba(255, 255, 255, 0.985)',
  border: 'rgba(17, 24, 39, 0.10)',
  logoGradient: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
  headerGradient: 'linear-gradient(180deg, rgba(5,150,105,0.97) 0%, rgba(4,120,87,0.98) 100%)',
  drawerGradient: 'linear-gradient(180deg, #FFFFFF 0%, #F0FDF4 100%)',
  indicatorGradient: 'linear-gradient(90deg, #F59E0B 0%, #D97706 100%)',
  buttonGradient: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
  buttonGradientHover: 'linear-gradient(135deg, #047857 0%, #065F46 100%)',
  pageBackground:
    'radial-gradient(circle at top left, rgba(5,150,105,0.04), transparent 24%), linear-gradient(180deg, #f9fffe 0%, #ffffff 16%, #ffffff 100%)',
};
